export const RESERVATION_STRATEGIES = [
    'service-employee',
    'service-resource-date',
    'service-resource-date-range',
    'service-branch-place-date',
    'service-branch-place-date-range'
]
